import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { WatermarkComponent } from './watermark.component';


@NgModule({
  declarations: [
    WatermarkComponent,
  ],
  exports: [
    WatermarkComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ]
})
export class WatermarkModule { }
